import { createFileRoute } from "@tanstack/react-router";
import { VolumesList } from "../../features/storage/volumes-list";

export const Route = createFileRoute("/_authed/$org/$project/volumes/")({
  validateSearch: (s: Record<string, unknown>): { q?: string } => (typeof s.q === "string" && s.q ? { q: s.q } : {}),
  component: VolumesPage,
});

function VolumesPage() {
  const { org, project } = Route.useParams();
  return <VolumesList scope={{ org, project }} search={Route.useSearch()} />;
}
